import {
    CONFIRMED_GET_KARMAS,
    CONFIRMED_CREATE_KARMA_ACTION,
    CONFIRMED_EDIT_KARMA_ACTION,
    CONFIRMED_DELETE_KARMA_ACTION,
  } from "./KarmaType"
  
  import { getKarmas, createKarma, updateKarma, deleteKarma, formatKarmas } from "../../services/KarmaService"
  
  import { showErrorAlert } from "../../services/ErrorHandlingService"
  
  export function getKarmasAction(
    pagination = false,
    pageid = 0,
    search_by = "",
    search_keyword = "",
    sort_order = "",
    sort_by = "",
  ) {
    return async (dispatch) => {
      try {
        const response = await getKarmas(pagination, pageid, search_by, search_keyword, sort_order, sort_by)
  
        if (response?.status === 200 && response.data) {
          if (response.data.status === "success") {
            const list = formatKarmas(response.data.data)
            dispatch({
              type: CONFIRMED_GET_KARMAS,
              payload: { karmas: list, num_rows: response.data.num_rows || list.length || 0 },
            })
          } else {
            showErrorAlert?.("Failed to fetch karma list")
          }
        } else {
          showErrorAlert?.("Network error fetching karma list")
        }
      } catch (error) {
        console.error("getKarmasAction error:", error)
        showErrorAlert?.("Failed to fetch karma list")
      }
    }
  }
  
  export function createKarmaAction(formData) {
    return async (dispatch) => {
      try {
        const response = await createKarma(formData)
        if (response?.data?.status === "success") {
          const created = response.data.data
          dispatch({ type: CONFIRMED_CREATE_KARMA_ACTION, payload: created })
          return { success: true, data: created }
        }
        throw new Error(response?.data?.message || "Failed to create karma")
      } catch (error) {
        console.error("createKarmaAction error:", error)
        showErrorAlert?.(error.message || "Failed to create karma")
        return { success: false, error: error.message }
      }
    }
  }
  
  export function updateKarmaAction(formData) {
    return async (dispatch) => {
      try {
        const response = await updateKarma(formData)
  
        if (response?.data?.status === "success") {
          // ✅ fallback if backend doesn’t return updated data
          const updated = response.data?.data || formData
  
          dispatch({ type: CONFIRMED_EDIT_KARMA_ACTION, payload: updated })
          return { success: true, data: updated }
        }
  
        throw new Error(response?.data?.message || "Failed to update karma")
      } catch (error) {
        console.error("updateKarmaAction error:", error)
        showErrorAlert?.(error.message || "Failed to update karma")
        return { success: false, error: error.message }
      }
    }
  }
  
  
  export function deleteKarmaAction(karma_id) {
    return async (dispatch) => {
      try {
        const response = await deleteKarma(karma_id)
        if (response?.data?.status === "success") {
          dispatch({ type: CONFIRMED_DELETE_KARMA_ACTION, payload: { karma_id } })
          return true
        }
        throw new Error(response?.data?.message || "Failed to delete karma")
      } catch (error) {
        console.error("deleteKarmaAction error:", error)
        showErrorAlert?.(error.message || "Failed to delete karma")
        return false
      }
    }
  }
  